import Base from './base'

export default class Box extends Base {
  getEmbedLink(fileId: string) {
    return this.apiClient.get(`box/embed-link/${fileId}`)
  }
}
